import React from "react";
import wasapayLogo from "../assets/img/btransfer-logo.svg";

const F_Header: React.FC = () => {
  return (
    <header className="py-4 mb-4 text-white">
      <div className="container mx-auto">
        <div className="flex items-center justify-between">
          <img src={wasapayLogo} alt="BT Payment" className="h-9 w-auto object-contain" />
          <button
            type="button"
            className="hidden sm:block text-white rounded-xl w-64 py-3 font-semibold transition-all shadow-md hover:opacity-90"
            style={{
              background:
                "linear-gradient(135deg, var(--SarepayPrimary-color) 0%, var(--Checkout-accent-color) 100%)",
            }}
          >
            Create a free account
          </button>
        </div>
      </div>
    </header>
  );
};

export default F_Header;
